import { render } from "./AddOwnHotels.vue?vue&type=template&id=3633c112&scoped=true"
import script from "./AddOwnHotels.vue?vue&type=script&lang=js"
export * from "./AddOwnHotels.vue?vue&type=script&lang=js"

import "./AddOwnHotels.vue?vue&type=style&index=0&id=3633c112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3633c112"]])

export default __exports__